import React, {useState} from 'react';
import {Field} from "../../components/layout/Form";
import firebase from "../../firebase";
import Swal from "sweetalert2";
import useForm from "../../hooks/useForm";

const AdddProduct = () => {

    const {values, handleChange, reset} = useForm({
        name: "",
        console: "",
        price: "",
        offer: "",
        edition: "",
        stock: "",
        priceOffer: "",
        categorie: "",
        format: "",
        description : "", 
    });
    const [imageUrl, setImageUrl] = useState("");
    let {name, console, price, offer, edition, priceOffer, categorie, format, description, stock} = values;

    const message = () => {
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Juego agregado correctamente',
            showConfirmButton: false,
            timer: 1500
          })
    }

    const onFileChange = async (e) => {
        const file = e.target.files[0];
        const storageRef = firebase.storage.ref();
        const fileRef = storageRef.child(file.name);
        await fileRef.put(file);
        setImageUrl(await fileRef.getDownloadURL());
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const product = {
            name, console, price, offer, edition, priceOffer, stock, categorie, format, description, imageUrl
        }

        if(console === "ps4"){
            await firebase.db.collection("ps4").add(product);
            message();
            reset();
        }
        else if(console === "ps5"){
            await firebase.db.collection("ps5").add(product);
            message();
            reset();
        }
        else if(console === "switch"){
            await firebase.db.collection("switch").add(product);
            message();
            reset();

        }


    }

    return (
        <div className="bg-add">
            <div className="container">
                <h1 className = "title">Agrega un nuevo producto a la base de datos</h1>
                <form onSubmit = {handleSubmit} className = "mt-5">
                    <div className="flex-center-column">
                        {/* <Fieldset> */}
                            {/* <Legend>Información Principal</Legend> */}
                            <Field>
                                <label htmlFor="">Nombre:</label>
                                <input type="text" name = "name" onChange  ={handleChange} value = {name}/>
                            </Field>
                            <Field>
                                <div className="flex-wrap">
                                    <label htmlFor="">Imagen: </label>
                                    <input type="file" onChange = {onFileChange}/>
                                </div>
                            </Field>
                            <Field>
                                <label htmlFor="">Consola:</label>
                                <select name="console" onChange ={handleChange} className = "ml-5" value = {console}>
                                    <option  defaultValue >--Seleccione una opción--</option>
                                    <option value="ps4">PS4</option>
                                    <option value="ps5">PS5</option>
                                    <option value="switch">Switch</option>
                                </select>
                            </Field>
                            <Field>
                            <label htmlFor="">Categoría:</label>
                            <select className = "ml-5" name = "categorie" onChange ={handleChange} value = {categorie}>
                            <option  defaultValue >--Seleccione una opción--</option>
                                <option value="action">Acción</option>
                                <option value="terror">Terror</option>
                                <option value="sport">Deporte</option>
                                <option value="adventure">Aventura</option>
                            </select>
                            </Field>
                            <Field>
                                <label htmlFor="">En Stock:</label>
                                <select name="stock" className = "ml-5" onChange = {handleChange} value  = {stock}>
                                    <option  defaultValue >--Seleccione una opción--</option>
                                    <option value="yes">Sí</option>
                                    <option value="no">No</option>
                                </select>
                            </Field>
                            <Field>
                                <label htmlFor="">Precio normal:</label>
                                <input type="number" name = "price" onChange ={handleChange} value = {price}/>
                            </Field>
                        {/* </Fieldset> */}
                        {/* <Fieldset > */}
                            {/* <Legend>Información Extra</Legend> */}
                            <Field>
                                <label htmlFor="">Oferta: </label>
                                <select name="offer" onChange ={handleChange} value = {offer}>
                                <option  defaultValue >--Seleccione una opción--</option>
                                    <option value="yes">Sí</option>
                                    <option value="no">No</option>
                                </select>
                            </Field>
                            <Field>
                                <label htmlFor="">Edición: </label>
                                <select name="edition" onChange ={handleChange} value = {edition}>
                                <option  defaultValue >--Seleccione una opción--</option>
                                    <option value="normal">Normal</option>
                                    <option value="deluxe">Deluxe</option>
                                    <option value="premium">Premium</option>

                                </select>
                            </Field>
                            <Field>
                                <label htmlFor="">Precio con oferta: </label>
                                <input type="number" name = "priceOffer" onChange ={handleChange} value = {priceOffer}/>
                            </Field>
                            <Field>
                                <label htmlFor="">Disponible en:</label>
                                <select className = "ml-5"name = "format" onChange ={handleChange} value = {format}>
                                <option  defaultValue >--Seleccione una opción--</option>
                                    <option value="fisic">Fisico</option>
                                    <option value="digital">Digital</option>
                                    <option value="both">Ambos</option>
                                </select>
                            </Field>
                            {/* <Field>
                                <label htmlFor="" className = "block">Descripción del juego:</label>
                                <textarea name="description" cols="50" rows="5"onChange ={handleChange} value = {description} ></textarea>
                            </Field> */}
                        {/* </Fieldset> */}
                        <div className="flex-center">
                            <input type="submit" className = "btn-submit"/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    
    );
}
 
export default AdddProduct;